import { CircularProgress, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import { QueryStatus } from '@reduxjs/toolkit/query';
import React from 'react';

import Withdraw from '@/assets/icons/withdraw.svg?react';
import { useTranslator } from '@/hooks/useTranslator';
import { ProofOfPaymentType } from '@/types/proofOfPaymentType';

interface Props {
  readonly disabled?: boolean;
  readonly status: QueryStatus;
  readonly type: ProofOfPaymentType;

  onClick(type: ProofOfPaymentType): void;
}

export const DownloadDocumentButton: React.FC<Props> = (props: Props): React.ReactElement => {
  const { type, disabled, status, onClick } = props;

  const onButtonClick = React.useCallback((): void => {
    onClick(type);
  }, [onClick, type]);

  const labelKey = React.useMemo((): string => `DOWNLOAD_${type}_TRANSACTION_DOCUMENT`, [type]);
  const tr = useTranslator();

  return (
    <ButtonBase
      disableRipple={true}
      disableTouchRipple={true}
      disabled={disabled}
      sx={styles.container}
      onClick={onButtonClick}>
      <Box display="flex" alignItems="center" color="primary.main" gap={1} height={30} my={1}>
        <Box display="flex" alignItems="center" justifyContent="center" width={24} height={24}>
          {status === QueryStatus.pending ? (
            <CircularProgress size={16} thickness={7} />
          ) : (
            <Withdraw fill="currentColor" />
          )}
        </Box>
        <Typography color="inherit" lineHeight="40px" fontSize="1rem">
          {tr(labelKey)}
        </Typography>
      </Box>
    </ButtonBase>
  );
};

const styles: Record<string, SystemStyleObject> = {
  container: {
    display: 'block',
  },
};
